<template>
    <el-dialog  :title="`${isEdit === true ? '编辑':'创建'}供应商`" :visible.sync="showDialog">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="form-beauty" :key="formIndex">
            <el-form-item label="跟进HR">{{$store.state.user.name}}</el-form-item>
            <!-- <el-form-item label="签约部门">{{$store.state.user.projectName}}</el-form-item> -->
            <el-form-item label="公司简称" prop="companyAbbr">
                <el-select v-model="ruleForm.companyAbbr" placeholder="请选择公司简称">
                    <el-option v-for="(company, key) in companyList" :key="key" :label="company.name" :value="company.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="公司全称" prop="companyFullName">
                <el-input v-model="ruleForm.companyFullName" placeholder="请输入公司全称" :maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="对接人姓名" prop="linkman">
                <el-input v-model="ruleForm.linkman" placeholder="请输入对接人姓名" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="对接人邮箱" prop="email">
                <el-input v-model="ruleForm.email" placeholder="请输入对接人邮箱" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="对接人电话" prop="tel">
                <el-input v-model="ruleForm.tel" placeholder="请输入对接人电话" :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="ruleForm.remark" placeholder="请输入备注" type="textarea" :maxlength="500"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="submitForm('ruleForm', true)" type="primary">完成</el-button>
            <el-button @click="submitForm('ruleForm', false)" type="primary" v-if="!isEdit">保存并添加下一位</el-button>
            <el-button @click="showDialog=false" v-else>取消</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/javascript">
    import pattern from 'modules/pattern'
    import formCommonMixin from 'mixins/formCommonMixin'
    import CompanyListMixin from './companyList'
    const Model = {
        id: '',
        companyAbbr: '',
        companyFullName: '',
        linkman: '',
        email: '',
        tel: '',
        remark: ''
    }
    export default {
        mixins: [formCommonMixin, CompanyListMixin],
        data () {
            return {
                showDialog: false,
                isEdit: false,
                formIndex: 1,
                ruleForm: Object.assign({}, Model),
                rules: {
                    companyAbbr: [
                        {required: true, message: '请选择公司简称', trigger: 'change'}
                    ],
                    companyFullName: [
                        {required: true, message: '请输入公司全称', trigger: 'change'}
                    ],
                    linkman: [
                        {required: true, message: '请输入对接人姓名', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: '请输入对接人邮箱', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change'}
                    ],
                    tel: [
                        {required: true, message: '请输入对接人电话', trigger: 'blur'},
                        {pattern: /^[0-9]+$/, message: '请输入数字', trigger: 'blur,change'}
                    ]
                }
            }
        },
        computed: {
        },
        methods: {
            show (isEdit = false, data) {
                this.isEdit = isEdit
                this.resetForm('ruleForm')
                if (data) {
                    for (let name in Model) {
                        this.ruleForm[name] = data[name]
                    }
                } else {
                    Object.assign(this.ruleForm, Model)
                }
                console.log(this.ruleForm)
                this.showDialog = true
            },
            saveForm (boolean) {
                let url = this.isEdit ? '/supplier/update.api' : '/supplier/insert.api'
                this.$axios.post(url, Object.assign({}, this.ruleForm), {'X-showMessage': true}).then(res => {
                    this.ruleForm = Object.assign(this.ruleForm, Model)
                    this.formIndex++
                    if (boolean === true) {
                        this.showDialog = false
                    }
                    this.$emit('reload')
                }).catch(() => {})
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";
</style>


// WEBPACK FOOTER //
// editSupplierDialog.vue?bffbd686